import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'legrandav-bodytext-primary',
  styleUrl: 'legrandav-bodytext-primary.css',
  shadow: true,
})
export class LegrandavBodytextPrimary {
  @Prop() text: string;

  render() {
    return (
      <Host>
        <div class="legrandav-bodytext-primary">{this.text}</div>
      </Host>
    );
  }
}
